import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './permission'

// 引入饿了么UI
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(Element, {
	size: 'small',
	zIndex: 3000
});
import '@/static/css/style.css' // global css

import store from '../store'

Vue.config.productionTip = false

// 引入图表
import ECharts from 'vue-echarts'
// 全局注册组件（也可以使用局部注册）
Vue.component('v-chart', ECharts)


new Vue({
	store,
	router,
	render: h => h(App),
}).$mount('#app')
